import axios from "axios";
let instance;

if (process.env.NODE_ENV === "production") {
  instance = axios.create({ baseURL: "https://kro-af.org/api" });
} else {
  instance = axios.create({ baseURL: "http://localhost:3900/api" });
}

instance.interceptors.request.use((config) => {
  config.headers["x-api-key"] = localStorage.getItem("auth_token");
  return config;
});

export default instance;
